import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin/deployment-center/')({
    beforeLoad: () => {
        throw redirect({
            to: '/admin/deployment-center/system-status'
        });
    }
})